import { EOrderStatus } from '@type/order';

export const APPLICATION_DATE_FORMAT = 'DD/MM/YYYY';
export const FORMAT_DATE_TIME = 'DD/MM/YYYY, HH:mm';
export const DATE_TIME_STAMP_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const MMM_DD_YYYY_FORMAT = 'MMM DD, YYYY';
export const FORMAT_DATE_HOUR = 'DD/MM/YYYY, HH';
export const TIME_STAMP_FORMAT = 'HH:mm:ss';
export const DD_MM_HH_MM_FORMAT = 'DD/MM - HH:mm';
export const FORMAT_DATE_TIME_VN = 'HH:mm, DD/MM/YYYY';
export const FORMAT_DATE_TIME_STRING_VN = 'HH:mm [ngày] DD/MM/YYYY';
export const FORMAT_DATE_TIME_STRING_EN = 'HH:mm [on] MMMM DD, YYYY';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const FORMAT_MONTH_STRING_VN = '[Tháng] MM, YYYY';
export const FORMAT_MONTH_STRING_EN = 'MMMM, YYYY';
// 0x00 address
export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export const OrderStatus = [
  {
    key: EOrderStatus.PENDING,
    color: '#FF8800',
    label: 'Chờ xác nhận',
    hasReason: false,
    hasShippingCode: false,
  },
  {
    key: EOrderStatus.CONFIRM,
    color: '#320A6B',
    label: 'Xác nhận',
    hasReason: false,
    hasShippingCode: false,
  },
  {
    key: EOrderStatus.SHIPPING,
    color: '#7B61FF',
    label: 'Đang giao',
    hasReason: false,
    hasShippingCode: true,
  },
  {
    key: EOrderStatus.COMPLETED,
    color: '#38C976',
    label: 'Đã giao',
    hasReason: false,
    hasShippingCode: false,
  },
  {
    key: EOrderStatus.CANCELED,
    color: '#FF4241',
    label: 'Đơn huỷ',
    hasReason: true,
    hasShippingCode: false,
  },
];

export const OrderPayment = [
  {
    key: EOrderStatus.PAID,
    color: '#00BFFF',
    label: 'Đã thanh toán',
    hasReason: false,
    hasShippingCode: false,
  },
  {
    key: EOrderStatus.DEBT,
    color: '#FF1493',
    label: 'Còn nợ',
    hasReason: true,
    hasShippingCode: false,
  },
];
